/*
 * Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

/** Defines a resize handle position. */
export enum ResizeHandlePosition {
  Left = "left",
  Right = "right"
}

/** Defines a resize handle event. */
export interface ResizeHandleSizeChangedEvent {
  /** The new size value (in pixels) emited by the resize handle. */
  value: number;
}
